// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UwZr","toggleWrap":"styles_toggleWrap__3qILV","content":"styles_content__3DOx7","selectAreaCode":"styles_selectAreaCode__9DurY"};